<template lang="pug">
  header.bg-top
    .center
      .box-top.custom-width
        el-row(:gutter="16")
          el-col(:xs="24", :sm="4", :md="4")
            router-link(:to="{name: 'counter'}", :class="collapseMenu?'center':''")
              img.logo(:src="require('@/assets/svg/logo-branca.svg')")
          el-col(:xs="24", :sm="20", :md="20")
            //- top-menu(:collapse="collapseMenu")
    .bg-footer-mail
      .center
        .custom-width
          h1.text-white {{$route.meta.name}}
</template>

<script>
  import TopMenu from '@/views/TopMenu'
  export default {
    components: {
      TopMenu
    },
    name: 'top-two',
    computed: {
      collapseMenu () {
        let self = this
        if (parseInt(self.$root.screenW) < 768) {
          return true
        }
        return false
      },
    },
  }
</script>

<style lang="sass" scoped>
  @import '../../assets/sass/bootloader'
  .bg-top
    background: $c-bg-footer
  .bg-footer-mail
    background: $c-accent
    padding: 64px 0
    margin: 0
    position: relative
    h1
      font-size: $f-size*2
      position: relative
      z-index: 2
    &::after
      content: ' '
      display: block
      width: 100%
      height: 100%
      background: url(../../assets/svg/logo.svg) right 30% no-repeat
      background-size: 45%
      opacity: 0.5
      position: absolute
      left: 0
      top: 0
      z-index: 1
      @media (max-width: 767px)
        background-size: 120%
        background-position: center
        opacity: 0.3
  .header
    min-height: 800px
    position: relative
    overflow: hidden
  .header p
    margin-bottom: 64px
    color: $c-black
  .header.has-bg
    overflow: hidden
    background-image: url(../../assets/svg/header-bg.svg)
    background-position: center -250px
    background-repeat: no-repeat
    @media (max-width: 767px)
      background-position: -350px -50px
  .header-img img
    width: 150%
  h2
    margin-block-start: 0.83em
    margin-block-end: 0.83em
    margin-inline-start: 0px
    margin-inline-end: 0px
    text-transform: unset
    font-style: normal
    font-family: 'Kanit', sans-serif
    font-size: $f-size*2
    color: $c-black
  h1
    margin-left: 16px
  .box-top
    padding: 8px 0
    @media (max-width: 767px)
      padding: 8px
    .logo
      max-height: 40px
      margin-top: $margin
      &:hover
        cursor: pointer
</style>